// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  background-color: var(--gray);
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 3px var(--accent);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/container/container.component.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,aAAA;EACA,qBAAA;EACA,iCAAA;AACJ","sourcesContent":["div {\n    background-color: var(--gray);\n    padding: 1rem;\n    border-radius: 0.5rem;\n    box-shadow: 0 0 3px var(--accent);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
